<template>
  <div id="appointment" class="appointment-wrap style4 pt-100 pb-75 bg-f">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
          <div class="section-title style2 text-center mb-40">
            <span>Book An Appointment</span>
            <h2>We're Providing Best Services To Our Customers</h2>
          </div>
        </div>
      </div>

      <div class="book-appointment">
        <form action="#">
          <div class="row">
            <div class="col-xl-3 col-lg-6 col-md-6">
              <div class="form-group">
                <input type="text" placeholder="Full Name" />
              </div>
            </div>
            <div class="col-xl-3 col-lg-6 col-md-6">
              <div class="form-group">
                <input type="text" placeholder="Email Address" />
              </div>
            </div>
            <div class="col-xl-3 col-lg-6 col-md-6">
              <div class="form-group">
                <input type="number" placeholder="Phone Number" />
              </div>
            </div>
            <div class="col-xl-3 col-lg-6 col-md-6">
              <div class="form-group">
                <input
                  type="text"
                  placeholder="Booking Date"
                  onfocus="(this.type='date')"
                  onblur="(this.type='text')"
                />
              </div>
            </div>

            <div class="col-xl-3 col-lg-6 col-md-6">
              <div class="form-group">
                <select name="dept" id="dept">
                  <option data-display="Select Department" value="0">
                    Department
                  </option>
                  <option value="1">Dental Health</option>
                  <option value="2">Physical Health</option>
                </select>
              </div>
            </div>

            <div class="col-xl-3 col-lg-6 col-md-6">
              <div class="form-group">
                <select name="doc" id="doc">
                  <option data-display="Select Doctor" value="0">
                    Select Doctor
                  </option>
                  <option value="1">Dr. Josef Henry</option>
                  <option value="2">Dr. Kevin Martin</option>
                </select>
              </div>
            </div>

            <div class="col-xl-3 col-lg-6 col-md-6">
              <div class="form-group">
                <input type="text" placeholder="Message" />
              </div>
            </div>

            <div class="col-xl-3 col-lg-6 col-md-6">
              <button type="submit" class="btn style2">
                Book An Appointment
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BookAnAppointment",
};
</script>